import { render, staticRenderFns } from "./CollectionTree.vue?vue&type=template&id=c3fcf5e8"
import script from "./CollectionTree.vue?vue&type=script&lang=js"
export * from "./CollectionTree.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports